module.exports = __webpack_public_path__ + "img/cross-arrows.78938813.svg";